/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner
 */
export interface UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner
     */
    selected_option: string;
}

/**
 * Check if a given object implements the UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner interface.
 */
export function instanceOfUpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "selected_option" in value;

    return isInstance;
}

export function UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerFromJSON(json: any): UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner {
    return UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerFromJSONTyped(json, false);
}

export function UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'selected_option': json['selected_option'],
    };
}

export function UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerToJSON(value?: UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'selected_option': value.selected_option,
    };
}

